export interface UsersInGroupsDivision {
  UsersInGroup: number;
  Division: string /* example: '0.5 - 1' */;
}
